import { __awaiter, __generator } from "tslib";
import { importKey } from '@office-start/encryption-utility';
export function executeEncryptionKeyDataFlow(identity) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var jwk, cryptoKey;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    jwk = (_a = identity.encryptionConfig) === null || _a === void 0 ? void 0 : _a.cryptoKey;
                    if (!jwk) {
                        return [2 /*return*/, {
                                key: null,
                            }];
                    }
                    return [4 /*yield*/, importKey(jwk)];
                case 1:
                    cryptoKey = _b.sent();
                    return [2 /*return*/, {
                            key: cryptoKey,
                        }];
            }
        });
    });
}
//# sourceMappingURL=executeEncryptionKeyDataFlow.js.map